import React from "react";
import { IntlProvider } from "react-intl";
import versionSelect from "@atlassiansox/multi-product-calculator";
import { StyleReset } from "../../base/StyleReset";
import { AnalyticsListener } from "@atlaskit/analytics-next";
import { sendAnalytics } from "../../utils/send-analytics";

const MultiProductCalculatorContainer = ({restartLabel,
					stepTitle,
					previousButtonLabel,
					nextButtonLabel,
					estimateLabel,
					billingCycleLabel,
					monthlyBillingCycleLabel,
					annuallyBillingCycleLabel,
					productsLabel,
					estimatedMonthlyCostLabel,
					estimatedAnnulaCostLabel,
					taxNotIncludedLabel,
					contactSalesLabel,
					downloadPdfLabel,
					planLabel,
					numberOfUsersLabel,
					removeLabel,
					freeLabel,
					perUserTypeLabel,
					perAgentTypeLabel,
					perCreatorTypeLabel,
					addMarketplaceAppsLabel,
					searchMarketplaceAppsLabel,
					enterAppNameLabel,
					noMatchesLabel,
					addProductLabel,
					selectYourProductsLabel,
					addProductDetailsLabel,
					productLimitErrorMessage1,
					productLimitErrorMessage2,
					usersLabel,
					agentsLabel,
					creatorsLabel,
					numberOfLabel,
					userTierLabel,
					agentTierLabel,
					creatorsTierLabel,
					isMaxForLabel,
					minUsersLabel,
					enterpriseAnnualOnlyLabel,
					enterprisePlanPricingUsersLabel,
					enterprisePlanPricingAgentsLabel,
					enterprisePlanPricingCreatorsLabel,
					contactSalesTeamLabel,
					contactSalesTeamURL,
					aboutOptionsLabel,
					appLabel,
					appDisclaimerLabel,
					pricingDisclaimerLabel,
					estimateDateLabel,
					estimateOnlyLabel,
					questionsLabel,
					productLabel,
					userTypeInPdfLabel,
					pageNumberInPdfLabel,
					costPerLabel,
					NumberAndLabel,
					tierLabelInPdf,
					appCardUnexpectedError,
					appCardPricingDataMissingError}) => {
  return (
    <StyleReset>
      <AnalyticsListener onEvent={sendAnalytics}>
        <IntlProvider locale={document.documentElement.lang}>
          {versionSelect({
            version: 0,
            fields: {
              restartLabel,
					stepTitle,
					previousButtonLabel,
					nextButtonLabel,
					estimateLabel,
					billingCycleLabel,
					monthlyBillingCycleLabel,
					annuallyBillingCycleLabel,
					productsLabel,
					estimatedMonthlyCostLabel,
					estimatedAnnulaCostLabel,
					taxNotIncludedLabel,
					contactSalesLabel,
					downloadPdfLabel,
					planLabel,
					numberOfUsersLabel,
					removeLabel,
					freeLabel,
					perUserTypeLabel,
					perAgentTypeLabel,
					perCreatorTypeLabel,
					addMarketplaceAppsLabel,
					searchMarketplaceAppsLabel,
					enterAppNameLabel,
					noMatchesLabel,
					addProductLabel,
					selectYourProductsLabel,
					addProductDetailsLabel,
					productLimitErrorMessage1,
					productLimitErrorMessage2,
					usersLabel,
					agentsLabel,
					creatorsLabel,
					numberOfLabel,
					userTierLabel,
					agentTierLabel,
					creatorsTierLabel,
					isMaxForLabel,
					minUsersLabel,
					enterpriseAnnualOnlyLabel,
					enterprisePlanPricingUsersLabel,
					enterprisePlanPricingAgentsLabel,
					enterprisePlanPricingCreatorsLabel,
					contactSalesTeamLabel,
					contactSalesTeamURL,
					aboutOptionsLabel,
					appLabel,
					appDisclaimerLabel,
					pricingDisclaimerLabel,
					estimateDateLabel,
					estimateOnlyLabel,
					questionsLabel,
					productLabel,
					userTypeInPdfLabel,
					pageNumberInPdfLabel,
					costPerLabel,
					NumberAndLabel,
					tierLabelInPdf,
					appCardUnexpectedError,
					appCardPricingDataMissingError
            }
          })}
        </IntlProvider>
      </AnalyticsListener>
    </StyleReset>
  );
};

export default MultiProductCalculatorContainer;